import type {RepositoryMigratingNotice as RepositoryMigratingNoticePayload} from '@github-ui/code-view-types'
import {Banner, Link} from '@primer/react'

import {TradeControlsBanner} from '../trade-controls-banner/TradeControlsBanner'

interface RepositoryMigratingNoticeProps {
  migratingNotice?: RepositoryMigratingNoticePayload
  ownerLogin: string
  returnFocusIds?: string[]
}

export function RepositoryMigratingNotice({
  migratingNotice,
  ownerLogin,
  returnFocusIds,
}: RepositoryMigratingNoticeProps) {
  if (!migratingNotice) return null

  switch (migratingNotice.kind) {
    case 'in_progress':
      return <InProgressNotice />
    case 'exported':
      return <ExportedNotice exportedToUrl={migratingNotice.exportedToUrl} ownerLogin={ownerLogin} />
    case 'trade_controls':
      return <TradeControlsBanner notice={migratingNotice} returnFocusIds={returnFocusIds} />
  }
}

function InProgressNotice() {
  return (
    <Banner variant="warning" title="Repository migration notice" hideTitle flush>
      <Banner.Description>
        This repository is currently being migrated. It&apos;s locked while the migration is in progress.
      </Banner.Description>
    </Banner>
  )
}

function ExportedNotice({exportedToUrl, ownerLogin}: {exportedToUrl: string; ownerLogin: string}) {
  return (
    <Banner variant="warning" title="Repository migration notice" hideTitle flush>
      <Banner.Description>
        This repository has been migrated to another deployment of GitHub. You can now access it at{' '}
        <strong>
          <Link inline href={exportedToUrl}>
            {exportedToUrl}
          </Link>
        </strong>
        . Please contact the repository&apos;s owner,{' '}
        <strong>
          <Link inline href={`/${ownerLogin}`}>
            {ownerLogin}
          </Link>
        </strong>
        , for more information.
      </Banner.Description>
    </Banner>
  )
}
